import { Fragment, memo } from 'react'

import { List } from '@tribeplatform/react-ui-kit/Layout'

export const SearchLoading = memo(
  ({
    multiSection = false,
    rowCount = 3,
  }: {
    multiSection?: boolean
    rowCount?: number
  }) => {
    return (
      <>
        {[...Array(multiSection ? 4 : 1)].map((_e, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={i}>
            {multiSection && (
              <div className="px-2 pb-3 animate-pulse">
                <div className="h-2 bg-surface-subdued rounded-full w-1/12" />
              </div>
            )}
            <List spacing="none" divider>
              {[...Array(rowCount)].map((_e, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <List.Item key={i}>
                  <div className="flex gap-1 items-center px-4 lg:px-5 py-5">
                    <div className="animate-pulse bg-skeleton rounded-avatar w-8 h-8 gap-2" />

                    <div className="animate-pulse flex flex-col gap-2 flex-1">
                      <div className="flex justify-between">
                        <div className="h-2 bg-skeleton rounded-full w-5/12" />
                        <div className="h-2 bg-skeleton rounded-full w-2/12" />
                      </div>

                      <div className="flex justify-between">
                        <div className="h-2 bg-skeleton rounded-full w-8/12" />
                        <div className="h-2 bg-skeleton rounded-full w-2/12" />
                      </div>
                    </div>
                  </div>
                </List.Item>
              ))}
            </List>
          </Fragment>
        ))}
      </>
    )
  },
)
